import * as _ from 'lodash';

const isPagePathVisible = (module, pagePath, pageVisibilities) => {
  const moduleId = parseInt(module, 10);
  const pages = _.filter(
    pageVisibilities,
    (pageVisibility) => pageVisibility.page === pagePath && pageVisibility.module === moduleId
  );

  // to be safe, if no record in toc, always return true
  if (pages.length >= 1) {
    return pages[0].visible;
  }

  return true;
};

export default isPagePathVisible;
